module.exports = __webpack_public_path__ + "img/375e1da.png";